import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Modal, message } from "antd";
import React from "react";
import { PostAPIRequest } from "../../services";
import NewItemForm from "../NewItemForm";

const AddBrand = (props) => {
  const [visible, setVisible] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [form] = Form.useForm();
  const showModal = () => {
    setVisible(true);
  };

  const handleOk = async () => {
    const row = await form.validateFields();
    console.log("Received values of form: ", row);

    var url = "/launchtracker/api/v1/brand/save";
    PostAPIRequest({
      url: url,
      data: row,
    }).then((response) => {
      message.success("Successfully created")
      setConfirmLoading(true);
      setTimeout(() => {
        setVisible(false);
        setConfirmLoading(false);
      }, 1000);
      form.resetFields();
      props.callback();
    }).catch((error) => {
      message.error("Something went wrong. Please try again later.")
    });
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button size="large" type="primary" onClick={showModal}>
        <PlusCircleOutlined />
        Add Brand
      </Button>
      <Modal
        bodyStyle={{ overflowX: "auto", maxHeight: "calc(80vh - 200px)" }}
        title="Add Brand"
        visible={visible}
        width={600}
        onCancel={handleCancel}
        footer={[
          <Button key="back" className="cancel-btn ant-btn" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={confirmLoading}
            onClick={handleOk}
          >
            Submit
          </Button>,
        ]}
      >
        <NewItemForm handleCancel={handleCancel} form={form} brands={props.brands} tumors={props.tumors} />
      </Modal>
    </>
  );
};

export default AddBrand;
